import { InjectionToken } from '@angular/core';
import { UserProfile } from '@appFunctions/users/types';
import { Observable } from 'rxjs';

export interface FetchUser {
  doc: (id: string) => Observable<Partial<UserProfile> | undefined>;
}

export const FIREBASE_PIPES_FETCH_USER_TOKEN = new InjectionToken<FetchUser>('FIREBASE_PIPES_FETCH_USER_TOKEN');
